import { Navigation, Pagination, Keyboard } from 'swiper/modules';
import { addSlider } from '../helpers';

/**
 * DomReady
 *
 * @param {Function} callback
 */
const domReady = callback => {
	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		return callback();
	}

	document.addEventListener( 'DOMContentLoaded', callback );
};

/**
 * Enable navigation buttons after Swiper initialization
 *
 * @param {Array} sliderInstances - Array of Swiper instances
 */
const enableNavigationButtons = sliderInstances => {
	sliderInstances.forEach( swiperInstance => {
		if ( swiperInstance && typeof swiperInstance.on === 'function' ) {
			swiperInstance.on( 'init', () => {
				const slider = swiperInstance.el;
				const prevButton = slider.querySelector( '.slider-arrow--prev' );
				const nextButton = slider.querySelector( '.slider-arrow--next' );

				if ( prevButton ) {
					prevButton.removeAttribute( 'disabled' );
					prevButton.removeAttribute( 'aria-disabled' );
					prevButton.classList.remove( 'swiper-button-disabled' );
				}
				if ( nextButton ) {
					nextButton.removeAttribute( 'disabled' );
					nextButton.removeAttribute( 'aria-disabled' );
					nextButton.classList.remove( 'swiper-button-disabled' );
				}
			} );
		}
	} );
};

domReady( () => {
	const sliderKeyboardDisabled = document.body.classList.contains( 'has-swiper-keyboard-disabled' );

	const presets = {
		productCarousel: {
			modules: [ Navigation, Keyboard ],
			direction: 'horizontal',
			createElements: true,
			slidesPerView: 'auto',
			loop: true,
			watchSlidesProgress: true,
			threshold: 1,
			navigation: {
				nextEl: '.slider-arrow--next',
				prevEl: '.slider-arrow--prev',
				closest: '.container',
			},
			keyboard: {
				enabled: sliderKeyboardDisabled ? false : true,
			},
		},
		bulletSlider: {
			modules: [ Pagination, Keyboard ],
			direction: 'horizontal',
			createElements: true,
			slidesPerView: 'auto',
			watchSlidesProgress: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			allowTouchMove: true,
			setWrapperSize: true,
			keyboard: {
				enabled: sliderKeyboardDisabled ? false : true,
			},
		},
	};

	const sliders = {};

	sliders.popularProducts = addSlider(
		'.popular-products-slider',
		presets.productCarousel
	);
	enableNavigationButtons( sliders.popularProducts );

	sliders.productsCarousels = addSlider(
		'.products-slider',
		presets.productCarousel
	);
	enableNavigationButtons( sliders.productsCarousels );

	sliders.bestSellers = addSlider(
		'.wc-block-product-best-sellers',
		presets.productCarousel
	);
	enableNavigationButtons( sliders.bestSellers );

	( () => {
		const settings = {
			...presets.bulletSlider,
			setWrapperSize: false,
		};

		sliders.gridSlider = [
			...addSlider( '.slider-container-m', settings ),
			...addSlider( '.slider-container-s', settings ),
		];
		enableNavigationButtons( sliders.gridSlider );
	} )();
} );
